/** Station box widths inside `column_station_info` — header labels must match. */
export const COURSE_STATION_BOX_LEFT_WIDTH_PX = 30;
export const COURSE_STATION_BOX_RIGHT_WIDTH_PX = 81;

/** Max width for duration text + optional validation warning icon in the station row grid. */
export const COURSE_STATION_ROW_DURATION_COLUMN_MAX_WIDTH_PX = 78;

/** Desktop grid for course station rows — equal station column width, station expands on resize. */
export const COURSE_STATION_ROW_GRID_TEMPLATE =
  `minmax(0, 33px) minmax(0, 70px) minmax(0, 30px) minmax(0, 1fr) minmax(0, 130px) minmax(0, ${COURSE_STATION_ROW_DURATION_COLUMN_MAX_WIDTH_PX}px) minmax(0, 56px)` as const;

export const COURSE_STATION_ROW_GRID_GAP = "3px" as const;
